module.exports = __webpack_public_path__ + "f1c872fb2eece4207de3d27556abdf5e.svg";